import axios from "axios";
import { removeNullParamsFromObject } from "@/helpers/functions.helper.js";

const API = import.meta.env.VITE_API;

export default {
	/**
	 * Get info from logged user or from an specific user
	 * @param {string} email Optional. If not given, get info from logged user
	 *
	 * @return {Promise}
	 */
	get(email) {
		let url = `${API}/user`;

		if (email) {
			url += "s/" + email;
		}

		return axios
			.get(url)
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	getUserWithPrivileges(organizationId) {
		return axios
			.get(`${API}/user?organizationId=${organizationId}`)
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	/**
	 * Update user's info
	 * @param  {object} infos {fullName: string, phoneNumber: string, language: string}
	 *
	 * @return {Promise}
	 */
	update({ fullName = null, phoneNumber = null, language = null }) {
		return axios
			.put(`${API}/user`, {
				...removeNullParamsFromObject({
					fullName,
					phoneNumber,
					language
				})
			})
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	/**
	 * Update the user's own password
	 */
	updatePassword(username, password, passwordConfirm) {
		return axios
			.put(`${API}/user/password`, {
				username,
				password,
				passwordConfirm
			})
			.then((resp) => resp.data)
			.catch((err) => {
				throw err.response;
			});
	},

	addPrivileges(username, organizationId, privileges) {
		return axios
			.post(`${API}/users/${username}/privileges`, {
				organizationId,
				privileges
			})
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	removePrivilege(username, organizationId, privilegeId) {
		return axios
			.delete(`${API}/users/${username}/privileges`, {
				params: {
					organizationId,
					privilegeId
				}
			})
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	removeAllPrivileges(username, organizationId, genericOnly = false) {
		return axios
			.delete(`${API}/users/${username}/privileges`, {
				params: {
					organizationId,
					genericOnly
				}
			})
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	listEnrollments() {
		return axios
			.get(`${API}/user/enrollments`)
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	enableMfa() {
		return axios
			.post(`${API}/user/enableMfa`)
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	disableMfa() {
		return axios
			.post(`${API}/user/disableMfa`)
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	getSupportAccess() {
		return axios
			.get(`${API}/user/supportAccessGrant`)
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	enableAssistanceAccess({
		endDate = new Date().toISOString(),
		isUnlimited = false
	}) {
		return axios
			.put(`${API}/user/supportAccessGrant`, {
				endDate: isUnlimited ? null : endDate
			})
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	disableAssistanceAccess() {
		return axios
			.delete(`${API}/user/supportAccessGrant`)
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	},

	// used by support team
	getSupportAccessGrants() {
		return axios
			.get(`${API}/users/supportAccessGrants`)
			.then((res) => res.data)
			.catch((err) => {
				throw err.response;
			});
	}
};
